import axios from "axios";
import { toast } from "react-toastify";
import {decryptData} from '../crypto'
const baseURL = process.env.REACT_APP_API_BASE_URL;

const axios_instance = axios.create({
  baseURL:baseURL
});

export async function getRZPKey() {
  try {
    var response = await axios_instance.get(`v1/api/razorpay/key`); 
    console.log('Response:', response);
    return response;
  } catch (err) {
    console.error('Error in getRZPKey:', err);
    if (
      err?.response?.data?.message === "Invalid or expired token. Please refresh your session."
    ) {
      window.location.reload();
      localStorage.clear();
    } else if (
      err?.response?.data?.message === "You are logged out. Please log in again."
    ) {
      window.location.reload();
      localStorage.clear();
    } else if (err?.response?.data?.message) {
      toast.error(err?.response?.data?.message);
    }
  }
}

export const fetchProfileApi = async () => {
  const decryptedToken = decryptData(sessionStorage.getItem("token"));

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/auth/profile`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("API error:", error);

    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export async function UpgradePlan(payload, token) {
  try {
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
    
    const response = await axios_instance.post(`v1/b2b/upgradeplan`, payload, { headers });
    console.log('UpgradePlan response:', response);
    return response;
  } catch (err) {
    console.error('Error in UpgradePlan:', err);
    if (
      err?.response?.data?.message === "Invalid or expired token. Please refresh your session."
    ) {
      window.location.reload();
      localStorage.clear();
    } else if (
      err?.response?.data?.message === "You are logged out. Please log in again."
    ) {
      window.location.reload();
      localStorage.clear();
    } else if (err?.response?.data?.message) {
      toast.error(err?.response?.data?.message);
    }
  }
}

export async function getSlotListData(decryptedToken){
   try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/centers_slot`,
      {
        headers: {
          Authorization: `Bearer ${decryptData(sessionStorage.getItem("token"))}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching slot list:", error);
    throw error;
  }
}


export const fetchQuestionPaperApi = async (examId) => {
  // const decryptedToken = decryptData(sessionStorage.getItem("examToken"));
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/question/by_exam/${examId}`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const fetchExamDate = async () => {
  // const decryptedToken = decryptData(sessionStorage.getItem("examToken"));
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/by/date`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const fetchExamByDate = async (date) => {
  // const decryptedToken = decryptData(sessionStorage.getItem("examToken"));
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/one/by/date?start_date=${date}`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};
export const fetchCenterByDate = async (date) => {
  // const decryptedToken = decryptData(sessionStorage.getItem("examToken"));
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/sync/status/center/${date}`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};


export const Report2Api = async (id) => {
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/export/report02/${id}`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const Report6Api = async (id) => {
  // const decryptedToken = decryptData(sessionStorage.getItem("examToken"));
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/export/report06/${id}`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const Report7Api = async (id) => {
  // const decryptedToken = decryptData(sessionStorage.getItem("examToken"));
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/export/report07/${id}`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};


export const Report8Api = async (id) => {
  // const decryptedToken = decryptData(sessionStorage.getItem("examToken"));
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/export/merge/${id}`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};



export const dashboardApi = async (id) => {
  // const decryptedToken = decryptData(sessionStorage.getItem("examToken"));
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/export/giving/${id}`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};


export const fetchExamByBetweenDate = async (strDate,endDate) => {
  // const decryptedToken = decryptData(sessionStorage.getItem("examToken"));
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/by/beetweendate?start_date=${strDate}&end_date=${endDate}`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};

export const Report10Api = async (id,strDate,endDate) => {
  // const decryptedToken = decryptData(sessionStorage.getItem("examToken"));
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/export/report10/${id}?from_date=${strDate}&to_date=${endDate}`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};